// @flow
'use strict';

import * as React from 'react';

import type { ItemProps } from './types';

import RowDetalhes from '../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../common/detalhes_documento/column_detalhes';

export default function DadosBasicos({ item } : ItemProps) {
  return (
      <RowDetalhes className="table-condensed table-striped table-main no-margin-bottom" data={ item }>
        <ColumnDetalhes field="chave" width="60%" botaoCopiar>Chave de Acesso</ColumnDetalhes>
        <ColumnDetalhes field="numero" width="20%">Número CF-e</ColumnDetalhes>
        <ColumnDetalhes field="versao" width="20%">Versão</ColumnDetalhes>
      </RowDetalhes>
  );
}
